import { lazy, Suspense } from 'react';
import { Navigate, redirect, RouteObject } from 'react-router-dom';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';
import { MarketplaceListingsRouteEnum, MarketplaceRouteEnum } from '~/router/@types';

const MarketplaceListingsPage = lazy(() => import('~/pages/Marketplace/Listings'));
const MarketplaceReviewNeededPage = lazy(() => import('~/pages/Marketplace/ReviewNeeded'));

export const MARKETPLACE_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={`${MarketplaceRouteEnum.Listings}/${MarketplaceListingsRouteEnum.Flagged}`} replace />,
  },
  {
    path: MarketplaceRouteEnum.ReviewNeeded,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <MarketplaceReviewNeededPage />
      </Suspense>
    ),
  },
  {
    path: `${MarketplaceRouteEnum.Listings}/:tab?/:listingId?`,
    loader: async ({ params }) => {
      if (!params.tab) {
        return redirect('flagged');
      } else {
        return null;
      }
    },
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <MarketplaceListingsPage />
      </Suspense>
    ),
  },
];
